<template>
  <div>
    <AddPool @open-main-modal-again="openMainModal" />
    <EditPool @open-main-modal-again="openMainModal" />
    <button class="d-none" data-toggle="modal" data-target="#AddTournament" ref="openModalAddTournament"></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="AddTournament" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog product-cart-modal" role="document">
        <div class="modal-content p-0">
          <div class="modal-left-wrapper">
            <div class="modal-header">
              <h6 class="modal-title m-0">Add Division</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeModalAddTournament">
                <img src="../../../assets/Svg/close.svg" @click="reloadData" />
              </button>
            </div>
            <div class="modal-body mx-auto" style="width: 80%">
              <div class="container-fluid p-0">
                <div class="stepper d-flex justify-content-between">
                  <div class="step" :class="{ active: currentStep === 1, completed: currentStep > 1 }">
                    <div class="circle"></div>
                    <div class="label">Division Info</div>
                  </div>

                  <div class="step" :class="{ active: currentStep === 2, completed: currentStep > 2 }">
                    <div class="circle"></div>
                    <div class="label">Seed Criteria</div>
                  </div>

                  <div class="step" :class="{ active: currentStep === 3 }">
                    <div class="circle"></div>
                    <div class="label">Teams</div>
                  </div>
                </div>

              </div>
              <div v-if="currentStep === 1">

                <div class="form-group">
                  <input id="name" class="form-control" v-model="tournament_name" spellcheck="false" autocomplete="off"
                    trim type="text" required @input="errorNull" :class="{
                      'is-invalid': $v.tournament_name.$error,
                      'is-valid': !$v.tournament_name.$invalid,
                    }" />
                  <span v-if="!$v.tournament_name.required" class="invalid-tooltip">
                    division name is required
                  </span>
                  <span class="placeholder">Division Name</span>
                </div>
                <div class="row no-gutters">
                  <div class="col-sm-12 col-md-6 pr-0 pr-md-2">
                    <div class="form-group" :class="{ filled: startDate }">
                      <span class="event-error" v-if="startDateError != ''">
                        Please select Start Date.
                      </span>
                      <span class="event-error" v-if="eventStartDateError != ''">
                        Start date is outside the event date range.
                      </span>

                      <date-picker :open="open" @close="open = false" :editable="false" :clearable="false"
                      @click.native="open = true" v-model="startDate" valueType="format" format="MMM DD, YYYY"
                        @change="checkdate; errorNull">
                        <i slot="icon-calendar" class="cursor-pointer">
                          <img src="../../../assets/Svg/calendar.svg" />
                        </i>
                      </date-picker>
                      <span class="placeholder">Start Date</span>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 pl-lg-0">
                    <div class="form-group" :class="{ filled: endDate }">
                      <span class="event-error" v-if="endDate == '' && endDateError != ''">
                        Please select End Date.
                      </span>
                      <span class="event-error" v-if="endDateErrorGreater != ''">
                        End Date should be greater than start date
                      </span>
                      <span class="event-error" v-if="eventEndDateError != ''">
                        End date is outside the event date range.
                      </span>
                      <date-picker :open="openEnd" @close="openEnd = false" :editable="false" :clearable="false"
                      @click.native="openEnd = true" v-model="endDate" valueType="format" format="MMM DD, YYYY"
                        @change="checkdate; errorNull">
                        <i slot="icon-calendar" class="cursor-pointer">
                          <img src="../../../assets/Svg/calendar.svg" />
                        </i>
                      </date-picker>
                      <span class="placeholder">End Date</span>
                    </div>
                  </div>
                </div>

                <!-- <div class="col-12 p-0">
                  <div class="form-group">
                    <input id="time_limit" class="form-control" v-model="tournament_time" spellcheck="false"
                      autocomplete="off" trim type="number" required @input="errorNull" />
                    <span class="placeholder">Time Limit (minutes)</span>
                  </div>
                </div> -->
                <div class="col-12 p-0 mb-3">
                  <h6 class="mb-2 head-sec">Format</h6>
                  <div class="d-flex align-items-center justify-content-between">
                    <span class="custom-format">Use custom format for this division</span>
                    <toggle-button type="checkbox" class="m-0 p-0  d-flex justify-content-end" id="customFormat"
                      :width="34" :sync="true" :value="customFormat" v-model="customFormat" />
                  </div>
                </div>

                <div class="row no-gutters" v-if="customFormat">
                  <div class="col-12 col-md-6 pr-md-2">
                    <div class="form-group">
                      <span class="event-error" v-if="showErrors && !poolPlay">
                        Please select pool play guaranteed.
                      </span>
                      <select class="form-control" :class="{ filled: poolPlay }" v-model="poolPlay">
                        <option v-for="option in gameGuaranteeOptions" :key="option.id" :value="option.id"> {{
                          option.value }}
                        </option>
                      </select>
                      <span class="placeholder">Pool Play Guaranteed</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <span class="event-error" v-if="showErrors && !bracketFormat">
                        Please select bracket format.
                      </span>
                      <select class="form-control" :class="{ filled: bracketFormat }" v-model="bracketFormat">
                        <option v-for="option in bracketFormats" :key="option.id" :value="option"> {{
                          option.bracket_name }}
                        </option>
                      </select>
                      <span class="placeholder">Bracket Format</span>
                    </div>
                  </div>
                </div>

                <div class="col-12 p-0">
                  <h6 class="mb-3 head-sec">Time Limits (minutes)</h6>
                  <div class="row no-gutters">
                    <div class="col-12 col-lg-4">
                      <div class="form-group" :class="{ filled: poolPlayTime }">
                        <input type="text" class="form-control" id="poolPlayTime" v-model="poolPlayTime" required />
                        <span class="placeholder">Pool Play</span>
                      </div>
                    </div>

                    <div class="col-12 col-lg-4 px-lg-2">
                      <div class="form-group" :class="{ filled: bracketTime }">
                        <input type="text" class="form-control" id="bracketTime" v-model="bracketTime" required />
                        <span class="placeholder">Bracket</span>
                      </div>
                    </div>

                    <div class="col-12 col-lg-4">
                      <div class="form-group" :class="{ filled: championshipTime }">
                        <input type="text" class="form-control" id="championshipTime" v-model="championshipTime"
                          required />
                        <span class="placeholder">Championship</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 px-0 pt-0 pb-3">
                  <h6 class="mb-2 head-sec">Teams</h6>
                  <div class="d-flex align-items-center justify-content-between">
                    <span class="custom-format">
                      Only teams of specific ages and ratings will play in this division
                    </span>
                    <toggle-button type="checkbox" class="m-0 p-0 d-flex justify-content-end" id="isChecked" :width="34"
                      :sync="true" :value="isChecked" v-model="isChecked" />
                  </div>
                </div>

                <!-- Displayed when toggle is checked -->
                <div class="row no-gutters" v-if="isChecked">
                  <!-- Age Selection -->
                  <div class="col-12">
                    <div class="member-select">
                      <label class="typo__label" for="ajax">Age</label>
                      <multiselect v-model="selectedAge" :options="filteredOptionsAges" open-direction="bottom"
                        :multiple="true" :searchable="false" track-by="id" label="name" :internal-search="false"
                        :clear-on-select="false" placeholder="Select Age" :close-on-select="false" :options-limit="300"
                        :max-height="600" :hide-selected="true" @scroll.stop class="select-friends"
                        :class="{ 'is-invalid': showErrors && (!selectedAge || !selectedAge.length) }">
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <div class="custom__content">
                              <span class="user__name text-capitalize">{{ option.name }}</span>
                            </div>
                            <span class="custom__remove cursor-pointer" @click="remove(option)">
                              <img src="../../../assets/Svg/close.svg" alt="" />
                            </span>
                          </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                          <div class="multiselect__clear" v-if="selectedAge.length"
                            @mousedown.prevent.stop="clearAll(props.search)"></div>
                        </template>
                        <template slot="noResult">
                          No matching ages found. Try refining your search!
                        </template>
                        <template slot="noOptions">
                          No more ages to choose from.
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <div class="option__desc">
                            <span class="text-capitalize">{{ option.name }}</span>
                          </div>
                        </template>
                      </multiselect>
                      <p v-if="showErrors && (!selectedAge || !selectedAge.length)" class="invalid-tooltip">
                        Age is required.
                      </p>
                    </div>
                  </div>

                  <!-- Rating Selection -->
                  <div class="col-12 py-3">
                    <div class="member-select">
                      <label class="typo__label" for="ajax">Rating</label>
                      <multiselect v-model="selectedDivision" id="ajax" label="fname" class="select-friends"
                        track-by="id" placeholder="Select Rating" open-direction="top" :options="filteredOptionsRating"
                        :multiple="true" :searchable="false" :internal-search="false" :clear-on-select="false"
                        :close-on-select="false" :options-limit="300" :max-height="600" :hide-selected="true"
                        @scroll.stop
                        :class="{ 'is-invalid': showErrors && (!selectedDivision || !selectedDivision.length) }">
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <div class="custom__content">
                              <span class="user__name text-capitalize">{{ option.rate }}</span>
                            </div>
                            <span class="custom__remove cursor-pointer" @click="remove(option)">
                              <img src="../../../assets/Svg/close.svg" alt="" />
                            </span>
                          </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                          <div class="multiselect__clear" v-if="selectedDivision.length"
                            @mousedown.prevent.stop="clearAll(props.search)"></div>
                        </template>
                        <template slot="noResult">
                          No matching rating found. Try refining your search!
                        </template>
                        <template slot="noOptions">
                          No more rating to choose from.
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <div class="option__desc">
                            <span class="text-capitalize">{{ option.rate }}</span>
                          </div>
                        </template>
                      </multiselect>
                      <p v-if="showErrors && (!selectedDivision || !selectedDivision.length)" class="invalid-tooltip">
                        Rating is required.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-12 p-0">
                  <div class="form-group">
                    <input type="text" class="form-control" id="tournamentFormat" v-model="tournamentFormat"
                      @keyup="errorNull" required />
                    <span class="placeholder">Division Format</span>
                  </div>
                </div> -->
                <div class="col-12 p-0 my-3">
                  <div class="form-group">
                    <textarea type="text" rows="4" class="form-control" id="tournamentNotes" v-model="tournamentNotes"
                      @keyup="errorNull" required></textarea>
                    <span class="placeholder">Notes</span>
                  </div>
                </div>
              </div>
              <div v-if="currentStep === 2">
                <div class="mb-3 w-75 mx-auto">
                  <h6 class="mb-2 head-sec">Choose Seed Criteria</h6>
                  <div class="d-flex align-items-center justify-content-between">
                    <span class="custom-format">Use custom criteria for this division</span>
                    <toggle-button type="checkbox" class="m-0 p-0  d-flex justify-content-end" id="criteriaChecked"
                      :width="34" :sync="true" :value="criteriaChecked" v-model="criteriaChecked" />
                  </div>
                </div>
                <div class="teammates-lineup-wrapper mb-3" v-if="criteriaChecked">
                  <div class="available-teammates">
                    <h6>Available Seedars</h6>
                    <div class="teammates-info">
                      <draggable class="list-group" :list="availableSeedars" group="people" handle=".handle"
                        @change="handleAvailableSeedars" v-if="showLoaderAvailableParks == 0">
                        <div class="list-group-item" v-for="(element, index) in availableSeedars" :key="index">
                          <div class="shirt-no-wrapper">
                            <small>{{ index + 1 }}.</small>
                            <div class="d-flex flex-column">
                              <p class="name">{{ element?.criteria_name }}</p>
                            </div>
                          </div>
                          <div class="handle">
                            <img src="../../../assets/images/line-ellipsis.png" alt="" />
                          </div>
                        </div>
                      </draggable>
                      <div class="no-line-up" v-if="
                        showLoaderAvailableParks == 0 &&
                        availableSeedars.length == 0
                      ">
                        <div class="img">
                          <img src="../../../assets/images/teammates.png" alt="" />
                        </div>
                        <p class="text">No available seedars found.</p>
                      </div>
                      <div class="lds-dual-ring-media" v-if="showLoaderAvailableParks == 1"></div>
                    </div>
                  </div>
                  <div class="team-lineup mt-3 mt-md-0">
                    <h6>Selected Seedars</h6>
                    <div class="teammates-info position-relative">
                      <draggable class="list-group" :list="selectedSeedars" group="people" handle=".handle"
                        @change="handleSelectedSeedars" v-if="showLoaderSelectedParks == 0">
                        <div class="list-group-item" v-for="(element, index) in selectedSeedars"
                          :key="element?.position_index">
                          <div class="shirt-no-wrapper">
                            <small>{{ index + 1 }}.</small>
                            <div class="d-flex flex-column">
                              <p class="name">{{ element?.criteria_name }}</p>
                            </div>
                          </div>
                          <div class="handle">
                            <img src="../../../assets/images/line-ellipsis.png" alt="" />
                          </div>
                        </div>
                      </draggable>
                      <div class="no-line-up" v-if="
                        showLoaderSelectedParks == 0 &&
                        selectedSeedars.length == 0
                      ">
                        <div class="img">
                          <img src="../../../assets/images/teammates.png" alt="" />
                        </div>
                        <p class="text">No selected seedars found.</p>
                      </div>
                      <div class="lds-dual-ring-media" v-if="showLoaderSelectedParks == 1"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="currentStep === 3">
                <div class="tip-wrapper">
                  <span>Tip</span>
                  <p>Create multiple pools against the division (if required) and add teams into pool by dragging from
                    the Available
                    Teams list. These teams will be used for creating the pool play games and brackets for this
                    division. </p>
                </div>
                <div class="teammates-lineup-wrapper mb-3 teams-lineup">
                  <div class="available-teammates">
                    <h6>Available Event Teams</h6>
                    <div class="teammates-info overflow-hidden pb-5" style="height: 464px !important">
                      <div class="search-container border-0 mx-2">
                        <form>
                          <button type="button">
                            <img src="../../../assets/images/search.png" alt="" />
                          </button>
                          <input v-model="searchValue" id="search-input" type="text"
                            placeholder="Search by team name or city" name="search" autocomplete="new-password"
                            v-on:keydown.enter.prevent />
                        </form>
                      </div>
                      <draggable class="list-group" :list="filteredAvailableTeams" group="umpires" handle=".handle"
                        @change="handleAvailableTeams" v-if="showLoaderAvailableTeams == 0">
                        <div class="list-group-item cursor-none" v-for="(element, index) in filteredAvailableTeams"
                          :key="index">

                          <div class="shirt-no-wrapper">
                            <small>{{ index + 1 }}.</small>
                            <div class="d-flex flex-column">
                              <p class="name">{{ element?.team?.team_name }}</p>
                              <small class="pt-1 age-group-content text-capitalize">
                                {{ element?.team?.age_group?.name ? element.team.age_group.name + '-' : '' }}
                                {{ element?.team?.gender ? element.team.gender + '-' : '' }}
                                {{ element?.team?.ratings?.rate }}
                              </small>
                              <small class="pt-1 age-group-content text-capitalize">
                                {{ element?.team?.city }},
                                {{ element?.team?.state }}
                              </small>
                            </div>
                          </div>
                          <div class="handle cursor-pointer">
                            <img src="../../../assets/images/line-ellipsis.png" alt=""
                              title="Click an icon to drag and drop the option." />
                          </div>
                        </div>
                      </draggable>
                      <div class="no-line-up" v-if="showLoaderAvailableTeams == 0 && availableTeams.length == 0">
                        <div class="img">
                          <img src="../../../assets/images/teammates.png" alt="" />
                        </div>
                        <p class="text">No available Teams found.</p>
                      </div>
                      <div class="lds-dual-ring-media" v-if="showLoaderAvailableTeams == 1"></div>
                    </div>
                  </div>
                  <div class="team-lineup mt-3 mt-md-0">
                    <h6>Selected Division Teams</h6>
                    <div class="teammates-info position-relative teams-selected overflow-hidden">
                      <template>
                        <div class="d-flex align-items-center p-2">
                          <div class="form-group pool-select-input">
                            <select v-model="currentPoolName" class="pool-selection"
                              @change="getPoolSelectedTeamsForTournament(currentPoolName)"
                              :disabled="pools.length === 0">

                              <option disabled value="">
                                {{ pools.length === 0 ? 'Please add a pool to select' : 'Select Pool' }}
                              </option>

                              <option v-for="pool in pools" :key="pool.id" :value="pool.id">
                                {{ pool.pool_name }}
                              </option>
                            </select>
                          </div>
                          <div class="d-flex justify-content-between ml-2">
                            <div class="d-flex" style="gap:8px">
                              <div class="outline-icon cursor-pointer" @click="openEditPoolModal()"><img
                                  src="../../../assets/Svg/team/team-options/edit-2.svg" alt=""></div>
                              <div class="outline-icon cursor-pointer" @click="openAddPoolModal()">
                                <img src="../../../assets/Svg/add-btn.svg" alt="" />
                              </div>
                            </div>
                            <div class="event-btns-wrapper">
                              <button type="button" class="btn btn-primary btn-primary-custom" :disabled="isLoading"
                                @click="assignTeamsToPool()">
                                <div v-if="isLoading" class="lds-dual-ring"></div>
                                <div v-else>
                                  <img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save Pool Teams
                                </div>
                              </button>

                              <!-- <button v-else type="button" class="btn btn-primary-disabled" disabled>
                              <div>
                                <img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save Pool
                              </div>
                            </button> -->
                            </div>
                          </div>
                        </div>

                      </template>

                      <draggable class="list-group" :list="selectedTeams" group="umpires" handle=".handle"
                        @change="handleSelectedTeams" v-if="showLoaderSelectedTeams == 0">
                        <!-- Existing Layout -->
                        <div class="list-group-item cursor-none" v-for="(element, index) in selectedTeams"
                          :key="element?.position_index">
                          <div class="shirt-no-wrapper">
                            <small>{{ index + 1 }}.</small>
                            <div class="d-flex flex-column">

                              <p class="name">{{ element?.team?.team_name }}</p>
                              <small class="pt-1 age-group-content text-capitalize">
                                {{ element?.team?.age_group?.name ? element.team.age_group.name + '-' : '' }}
                                {{ element?.team?.gender ? element.team.gender + '-' : '' }}
                                {{ element?.team?.ratings?.rate }}
                              </small>
                              <small class="pt-1 age-group-content text-capitalize">
                                {{ element?.team?.city }},
                                {{ element?.team?.state }}
                              </small>
                            </div>
                          </div>
                          <div class="handle cursor-pointer">
                            <img src="../../../assets/images/line-ellipsis.png" alt=""
                              title="Click an icon to drag and drop the option." />
                          </div>
                        </div>
                      </draggable>
                      <div class="no-line-up" v-if="showLoaderSelectedTeams == 0 && selectedTeams.length == 0">
                        <div class="img">
                          <img src="../../../assets/images/teammates.png" alt="" />
                        </div>
                        <p class="text">No selected Teams found.</p>
                      </div>
                      <div class="no-line-up" v-else-if="errorMessage">
                        <div class="img">
                          <img src="../../../assets/images/teammates-red.png" alt="" />
                        </div>
                        <p class="text-danger pl-2">{{ errorMessage }}</p>
                      </div>
                      <div class="lds-dual-ring-media" v-if="showLoaderSelectedTeams == 1"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="event-btns-wrapper justify-content-end">
                <button v-if="!isDisabled" type="button" class="btn btn-primary" block @click="saveTournament(0)"
                  :disabled="isLoadingArray[0]">
                  <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
                  <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save & Continue</div>
                </button>
                <button v-else type="button" class="btn btn-primary-disabled" :disabled="isLoadingArray[0]">
                  <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
                  <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save & Continue</div>
                </button>
              </div> -->
              <div class="event-btns-wrapper"
                :class="{ 'justify-content-end': currentStep === 1, 'justify-content-between': currentStep !== 1 }">
                <button type="button" class="btn btn-prev" block @click="prevStep()" v-if="currentStep > 1">
                  Previous
                </button>
                <div class="d-flex align-items-center" style="gap: 10px;">
                  <button type="button" class="btn btn-skip" block @click="skipStep()" v-if="currentStep === 2">
                    Skip
                  </button>
                  <button type="button" class="btn btn-primary" block @click="handleStepsFunctions()"
                    :disabled="isLoadingArray[0]">
                    <div v-if="isLoadingArray[0]" class="d-flex align-items-center justify-content-center">
                      <div class="lds-dual-ring"></div>
                    </div>
                    <div v-else class="d-flex align-items-center">
                      <span v-if="currentStep <= 2">Save & Continue</span>
                      <span v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Close</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-right-wrapper">
            <DivisionSummary :tournamentName="tournament_name" :startDate="startDate" :endDate="endDate"
              :tournamentNotes="tournamentNotes" :selectedAges="selectedAge" :selectedRatings="selectedDivision"
              :events="events" :criteriaChecked="criteriaChecked" :custom-format="customFormat"
              :bracketFormat="bracketFormat" :bracketFormats="bracketFormats" :poolPlay="poolPlay"
              :availableEventSeedars="availableEventSeedars" :selectedSeedCriteria="selectedSeedars"
              :pools_data="pools_data" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { VueEditor, Quill } from 'vue2-editor';
import axios from "axios";
import DivisionSummary from "./DivisionSummary.vue"
import AddPool from "./AddPool.vue";
import EditPool from "./EditPool.vue";
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";
import {
  required
} from "vuelidate/lib/validators";

// Generate code-friendly font names
// function getFontName(font) {
//     return font.toLowerCase().replace(/\s/g, "-");
// }

// // Specify Quill fonts
// const fontList = ['Arial', 'Courier', 'Garamond', 'Tahoma', 'Times New Roman', 'Verdana', 'sans-serif', 'Serif', 'Monospace'];
// const fontNames = fontList.map(font => getFontName(font));
// const fonts = Quill.import('formats/font');
// fonts.whitelist = fontNames;
// Quill.register(fonts, true);

// // Add fonts to CSS style
// let fontStyles = "";
// fontList.forEach(function(font) {
//     let fontName = getFontName(font);
//     fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
//         "content: '" + font + "';" +
//         "font-family: '" + font + "', sans-serif;" +
//         "}" +
//         ".ql-font-" + fontName + "{" +
//         " font-family: '" + font + "', sans-serif;" +
//         "}";
// });
// const node = document.createElement('style');
// node.innerHTML = fontStyles;
// document.body.appendChild(node);

export default {
  name: "AddTournament",
  components: {
    // VueEditor
    DivisionSummary,
    Multiselect,
    draggable,
    AddPool,
    EditPool
  },
  data() {
    return {
      open: false,
      openEnd: false,
      startDate: null,
      endDate: null,
      exactStartDate: "",
      startDateForField: "",
      tournament_name: "",
      tournament_time: "",
      tournamentFormat: "",
      tournamentNotes: "",
      isChecked: false,
      endDateForField: "",
      exactEndDate: "",
      startDateError: "",
      eventStartDateError: "",
      eventEndDateError: "",
      endDateError: "",
      endDateErrorGreater: "",
      exactStartDateformat: "",
      exactEndDateformat: "",
      isDisabled: true,
      isLoadingArray: [],
      customFormat: false,
      criteriaChecked: false,
      selectedAge: [],
      selectedDivision: [],
      showErrors: false,
      startDateFormatted: "",
      tournament_id: "",
      tournament_guid: "",
      currentStep: 1,
      pools: [], // array of { name: string, teams: [] }
      pools_data: {},
      currentPoolName: "",
      newPoolName: "",
      poolPlay: '',
      bracketFormat: '',
      gameGuaranteeOptions: [
        { value: "1", id: "1" },
        { value: "2", id: "2" },
        { value: "3", id: "3" },
        { value: "4", id: "4" },
        { value: "5", id: "5" }
      ],
      selectedSeedars: [],
      availableEventSeedars: [],
      showLoaderSelectedParks: 1,
      availableSeedars: [],
      showLoaderAvailableParks: 1,

      availableTeams: [],
      selectedTeams: [],
      showLoaderSelectedTeams: 1,
      showLoaderAvailableTeams: 1,
      searchValue: "",
      errorMessage: "",
      showAddModal: false,
      showEditModal: false,
      editPoolName: '',
      isDisabledPool: true,
      isLoading: false,
      poolPlayTime: '',
      bracketTime: '',
      championshipTime: ''
    };
  },
  validations() {
    return {
      tournament_name: { required }
    }
  },
  props: {
    eventId: {
      type: Number,
    },
    association_id: {
      type: Number,
    },
    eventExactStartDate: {
      type: String,
    },
    eventExactEndDate: {
      type: String,
    },
    ratingOptions: {
      type: Array,
    },
    ageOptions: {
      type: Array,
    },
    bracketFormats: {
      type: Array,
    },
    events: {
      type: [Array, Object],
    },
  },
  watch: {
    tournament_name: "errorNull",
    startDate: "checkdate",
    endDate: "checkdate",
    tournamentFormat: "errorNull",

    isChecked(newValue) {
      // If the checkbox is unchecked, hide the errors
      if (!newValue) {
        this.selectedAge = [];
        this.selectedDivision = [];
        this.showErrors = false;
      }
    },
    pools(newVal) {
      if (!newVal.length) {
        this.currentPoolName = '';
      }
    },

    customFormat(newValue) {
      // If the checkbox is unchecked, hide the errors
      if (!newValue) {
        this.poolPlay = "";
        this.bracketFormat = "";
        this.showErrors = false;
      }
    },
    selectedTeams(newValue) {
      if (newValue.length > 0 || this.availableTeams.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    availableTeams(newValue) {
      if (newValue.length > 0 || this.selectedTeams.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },

    selectedSeedars: function (newValue) {
      if (newValue.length > 0 || this.availableSeedars.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    availableSeedars: function (newValue) {
      if (newValue.length > 0 || this.selectedSeedars.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    //   currentPoolName(newPoolId, oldPoolId) {
    //   if (newPoolId && newPoolId !== oldPoolId) {
    //     this.loadTeamsForPool(newPoolId);
    //   }
    // }
  },

  computed: {
    filteredOptionsAges() {
      return this.ageOptions; // disable filter temporarily to test
    },
    filteredOptionsRating() {
      if (this.ratingOptions.length === 0) {
        return [];
      }

      return this.ratingOptions.filter(rate =>
        !this.selectedDivision.some(selected => selected.id === rate.id)
      );
    },
    // isPoolSaveEnabled() {
    //   return this.currentPoolName && this.selectedTeams.length >= 1;
    // },
    filteredAvailableTeams() {
      const lowercasedSearchValue = this.searchValue.toLowerCase();
      return this.availableTeams.filter((team) => {
        const isSelected = this.selectedTeams.some(
          (selected) => selected.team.id === team.team.id
        );
        const teamName = team.team.team_name.toLowerCase();
        const city = (team.team.city || '').toLowerCase();

        return (
          !isSelected &&
          (teamName.includes(lowercasedSearchValue) ||
            city.includes(lowercasedSearchValue))
        );
      });
    },
  },
  methods: {
    reloadData() {
      this.$root.$emit('ReloadTabs');
      this.$root.$emit('fetchTournaments')
    },
    openMainModal() {
      var elem = this.$refs.openModalAddTournament;
      if (elem) {
        elem.click();
      }
    },

    handleAvailableSeedars(evt) {
      if (evt.added) {
        this.selectedSeedars.push(evt.added.element);
      }
    },
    handleSelectedSeedars(evt) {
      if (evt.removed) {
        const index = this.selectedSeedars.indexOf(evt.removed.element);
        if (index > -1) {
          this.selectedSeedars.splice(index, 1);
        }
      }
    },
    handleStepsFunctions() {
      if (this.currentStep === 1) {
        this.saveTournament(0);
      }
      else if (this.currentStep === 2) {
        this.manageTournamentSeedars(0);
      }
      else {
        this.manageTournamentTeam(0);
      }
    },
    async getSeedarsForAssociation() {
      try {
        this.showLoaderSelectedParks = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/getDefaultSeedars?tournament_id=${this.tournament_id}&association_id=${this.association_id}`
        );

        if (response.data.statusCode === 200) {
          this.selectedSeedars = Object.values(response.data.data);
          this.showLoaderSelectedParks = 0;
        } else {
          this.closeModal();
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderSelectedParks = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderSelectedParks = 0;
      }
    },
    async getTournamentSeedars() {
      try {
        this.showLoaderAvailableParks = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/fetchFilteredSeedarsTournament?tournament_id=${this.tournament_id}&association_id=${this.association_id}`
        );

        if (response.data.statusCode === 200) {
          this.availableSeedars = Object.values(response.data.data);
          this.showLoaderAvailableParks = 0;
        }
        else if (response.data.statusCode === 404) {
          this.closeModal();
          this.showLoaderAvailableParks = 0;
          // this.$alert(response.data.message, "Error");
          // this.$router.push({ name: "Teams" });
        }
        else {
          this.closeModal();
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderAvailableParks = 0;
        }
      } catch (error) {
        this.closeModal();
        this.errorMessage = "Failed to fetch data";
        this.showLoaderAvailableParks = 0;
      }
    },
    // async manageTournamentTeam(index) {
    //   this.isDisabled = false;
    //   //   if (this.selectedTeams.length < 2 && this.selectedTeams.length > 0) {
    //   //   this.errorMessage = "Please select at least two teams.";
    //   //   return;
    //   // }
    //   // if (this.selectedTeams.length === 0) {
    //   //   this.errorMessage = "Please select at least one team.";
    //   //   return;
    //   // }

    //   this.$set(this.isLoadingArray, index, true);

    //   // const { event_id, id: tournament_id, guid: tournament_guid } = this.tournamentData;

    //   try {
    //     const url = `${process.env.VUE_APP_API_URL}tournaments/teams/addTeamsToTournament`;
    //     const response = await axios.post(url, {
    //       event_id: this.eventId,
    //       selectedTeams: this.selectedTeams,
    //       tournament_id: this.tournament_id,
    //       tournament_guid: this.tournament_guid,
    //     });

    //     if (response.data.statusCode === 200) {
    //       this.isDisabled = true;

    //       if (response.data.associatedTeam == 1) {
    //         this.$alert(response.data.message);
    //       } else {
    //         this.$alert(response.data.message, "Success");
    //       }
    //       this.$root.$emit("selectedTournamentTeamEmit");
    //       this.$root.$emit("fetchTournaments"); // Refresh tournaments
    //       const elem = this.$refs.openAddTournamentModal;
    //       this.dataReset();
    //       if (elem) {
    //         elem.click();
    //       }
    //     } else if (response.data.statusCode === 404) {
    //       this.isDisabled = true;
    //       this.$alert(response.data.message, "Error");
    //       this.$router.push({ name: "Teams" });
    //       this.showLoader1 = 0;
    //     } else {
    //       console.error("Failed to add teams. Status:", response.status);
    //     }
    //   } catch (error) {
    //     console.error("Error saving selected teams:", error);
    //   } finally {
    //     this.isDisabled = true;
    //     this.$set(this.isLoadingArray, index, false);
    //   }
    // },



    nextStep() {
      if (this.currentStep < 3) {
        this.currentStep++;

        if (this.currentStep === 3) {
          this.availableTeams = [];
          this.selectedTeams = [];
          this.getSelectedTeamsForTournament();
          this.getTeamsForTournament();
        }
      }
    },
    skipStep() {
      if (this.currentStep === 2) {
        this.criteriaChecked = false;
        this.selectedSeedars = [];
      }
      if (this.currentStep < 3) {
        this.currentStep++;
      }
      if (this.currentStep === 3) {
        this.availableTeams = [];
        this.selectedTeams = [];
        this.getSelectedTeamsForTournament();
        this.getTeamsForTournament();
      }
    },
    prevStep() {
      if (this.currentStep > 1) this.currentStep--;
    },
    initializeDate() {
      // Ensure the date is valid and set it to the date picker
      if (this.eventExactStartDate) {
        this.startDate = this.formatDate(this.eventExactStartDate);
      }
      if (this.eventExactEndDate) {
        this.endDate = this.formatDate(this.eventExactEndDate);
      }
      this.checkdate();
      this.checkTimeDate();
    },
    async getEventSeedars() {
      try {

        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getEventSelectedSeedars`,
          {
            params: {
              event_id: this.eventId,
              association_id: this.association_id, // Pass association_id here
            }
          }
        );

        if (response.data.statusCode === 200) {
          this.availableEventSeedars = Object.values(response.data.data);
        }

        else {
          this.errorMessage = response.data.message || "Unknown error occurred";
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
      }
    },

    formatDate(date) {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const d = new Date(date);
      const month = monthNames[d.getMonth()];
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear();

      return `${month} ${day}, ${year}`;
    },

    dataReset() {
      this.$v.$reset();
      this.tournament_name = "";
      this.tournament_time = "";
      this.selectedAge = "";
      this.selectedDivision = [];
      this.startDate = "";
      this.endDate = "";
      this.tournamentFormat = "";
      this.tournamentNotes = "";
      this.exactStartDate = "";
      this.exactEndDate = "";
      this.startDateError = "";
      this.eventStartDateError = "";
      this.eventEndDateError = "";
      this.endDateError = "";
      this.endDateErrorGreater = "";
      this.showErrors = false;
      this.isChecked = false;
      this.customFormat = false;
      this.criteriaChecked = false;
      this.poolPlayTime = this.events.pool_play_time;
      this.bracketTime = this.events.bracket_time;
      this.championshipTime = this.events.championship_time;
    },
    dataReset2() {
      this.availableTeams = [];
      this.selectedTeams = [];
      this.pools = [];
      this.selectedSeedars = [];
      // this.availableEventSeedars = [];
      this.pools_data = {};
      this.currentPoolName = "";
      this.currentStep = 1;
      this.tournament_name = "";
      this.tournament_time = "";
      this.selectedAge = "";
      this.selectedDivision = [];
      this.startDate = "";
      this.endDate = "";
      this.tournamentFormat = "";
      this.tournamentNotes = "";
      this.exactStartDate = "";
      this.exactEndDate = "";
      this.startDateError = "";
      this.eventStartDateError = "";
      this.eventEndDateError = "";
      this.endDateError = "";
      this.endDateErrorGreater = "";
      this.showErrors = false;
      this.isChecked = false;
      this.customFormat = false;
      this.criteriaChecked = false
      this.tournament_id = "";
      this.tournament_guid = "";
      this.poolPlayTime = this.events.pool_play_time;
      this.bracketTime = this.events.bracket_time;
      this.championshipTime = this.events.championship_time;
    },
    errorNull() {
      if (!this.tournament_name || !this.startDate || !this.endDate || this.eventStartDateError || this.eventEndDateError || this.endDateErrorGreater !== "") {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    checkdate: function () {
      const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      // Event exact start and end date
      const eventExactStart = new Date(this.eventExactStartDate);
      const eventExactEnd = new Date(this.eventExactEndDate);
      eventExactStart.setHours(12, 0, 0, 0);
      eventExactEnd.setHours(12, 0, 0, 0);

      // Start Date
      if (this.startDate.length === 12) {
        const startDateObj = new Date(this.startDate);
        startDateObj.setHours(12, 0, 0, 0);

        this.startDateFormatted = startDateObj;
        this.exactStartDateformat = this.startDateFormatted;
        this.startDateForField = startDateObj.toISOString().split("T")[0];
        this.exactStartDate = `${month[startDateObj.getMonth()]} ${startDateObj.getDate()}, ${startDateObj.getFullYear()}`;

        // Check if start date is within event start and end dates
        this.eventStartDateError = (startDateObj < eventExactStart || startDateObj > eventExactEnd) ? "on" : "";
      }

      // End Date
      if (this.endDate.length === 12) {
        const endDateObj = new Date(this.endDate);
        endDateObj.setHours(12, 0, 0, 0);

        this.exactEndDateformat = endDateObj;
        this.endDateForField = endDateObj.toISOString().split("T")[0];
        this.exactEndDate = `${month[endDateObj.getMonth()]} ${endDateObj.getDate()}, ${endDateObj.getFullYear()}`;

        // Check if end date is within event start and end dates
        this.eventEndDateError = (endDateObj < eventExactStart || endDateObj > eventExactEnd) ? "on" : "";

        // Ensure end date is not before start date
        if (endDateObj < this.startDateFormatted && !this.eventEndDateError && !this.eventStartDateError) {
          this.endDateError = "";
          this.endDateErrorGreater = "on";
          this.exactEndDate = "";
          this.isDisabledEvent = true;
        } else {
          this.endDateError = "";
          this.endDateErrorGreater = "";
        }
      }

      this.checkTimeDate();
    },
    checkTimeDate() {
      if (!this.exactStartDate && this.exactEndDate) {
        this.startDateError = "on";
      } else {
        this.startDateError = "";
      }

      if (!this.exactEndDate && this.exactStartDate) {
        this.endDateError = "on";
      } else {
        this.endDateError = "";
      }

      // if (this.exactStartDate && this.exactEndDate) {
      this.errorNull();
      // }
    },
    async manageTournamentSeedars(index) {

      this.$set(this.isLoadingArray, index, true);
      try {
        if (this.currentStep === 2 && this.criteriaChecked && this.selectedSeedars.length === 0) {
          this.$alert('Please select at least one seeder before proceeding.');
          this.$set(this.isLoadingArray, index, false);
          return; // Stop execution
        }

        const url = `${process.env.VUE_APP_API_URL}tournaments/updateTournamentSeedCriteria`;
        const response = await axios.post(url, {
          tournament_id: this.tournament_id,
          seed_criteria_defaults: this.selectedSeedars,
          association_id: this.association_id,
          criteriaChecked: this.criteriaChecked
        });
        if (response.data.statusCode === 200) {
          this.getSelectedTeamsForTournament();
          this.getTeamsForTournament();
          this.nextStep();
          this.$set(this.isLoadingArray, index, false);
        } else if (response.data.statusCode === 404) {
          this.$set(this.isLoadingArray, index, false);
          this.closeModal();
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
        } else {
          this.errorMessage = response.data.message || "An error occurred while updating seed criteria.";
        }
      } catch (error) {
        console.error("Error saving selected Seedars:", error);
        // this.errorMessage = "Failed to update seed criteria. Please try again.";
      } finally {
        this.$set(this.isLoadingArray, index, false);
      }
    },
    saveTournament(index) {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error || this.$v.$invalid ||
        (this.isChecked && (!this.selectedAge || !this.selectedAge.length || !this.selectedDivision || !this.selectedDivision.length))) {
        if (this.isChecked && (!this.selectedAge || !this.selectedAge.length || !this.selectedDivision || !this.selectedDivision.length)) {
          this.showErrors = true; // show validation errors
        }
        return;
      }

      if (this.eventStartDateError !== '' || this.eventEndDateError !== '' || this.endDateErrorGreater !== '') {
        return
      }

      if (this.isChecked) {
        if (!this.selectedAge || !this.selectedAge.length || !this.selectedDivision || !this.selectedDivision.length) {
          this.showErrors = true; // show validation errors
          return;
        }


        else {
          const formData = {
            event_id: this.eventId,
            tournamentName: this.tournament_name,
            time_limit: this.tournament_time,
            format: this.tournamentFormat,
            customFormat: this.customFormat,
            notes: this.tournamentNotes,
            startDateForField: this.startDateForField,
            endDateForField: this.endDateForField,
            startDate: this.exactStartDateformat,
            endDate: this.exactEndDateformat,
            exactStartDate: this.exactStartDate,
            exactEndDate: this.exactEndDate,
            association_id: this.association_id,
            rate_id: this.isChecked ? this.selectedDivision.map(item => item.id).join(',') : '0',
            age_group: this.isChecked ? this.selectedAge.map(item => item.id).join(',') : '',
            pool_play: this.customFormat ? this.poolPlay : '',
            bracket_format: this.customFormat ? this.bracketFormat.id : '',
            pool_play_time: this.poolPlayTime ? this.poolPlayTime : 65,
            bracket_time: this.bracketTime ? this.bracketTime : 70,
            championship_time: this.championshipTime ? this.championshipTime : 80,
          };
          if (this.tournament_id) {
            formData.tournament_id = this.tournament_id;
          }
          this.$set(this.isLoadingArray, index, true);

          axios.post('/associationEvent/createTournament', formData)
            .then(response => {
              try {
                if (response.data.statusCode === 200) {
                  this.tournament_id = response.data.data.tournament_id
                  this.tournament_guid = response.data.data.tournament_guid
                  this.getTournamentSeedars();
                  this.getSeedarsForAssociation();
                  this.$set(this.isLoadingArray, index, false);
                  this.nextStep();
                } else if (response.data.statusCode === 404) {
                  this.$refs.closeModalAddTournament.click();
                  this.$set(this.isLoadingArray, index, false);
                  this.$alert(response.data.message, 'Error');
                  this.$router.push({ name: "Teams" });
                } else {
                  this.$set(this.isLoadingArray, index, false);
                  this.$alert(response.data.message || "An unknown error occurred.");
                }
              } catch (err) {
                // This will now catch errors within the .then block
                console.error("Error during processing response: ", err);
                this.$set(this.isLoadingArray, index, false);
                this.$alert("Something went wrong while processing the response.");
              }
            })
            .catch(error => {
              console.error("Request failed: ", error);
              this.$set(this.isLoadingArray, index, false);
              this.$alert("Failed to create tournament. Please try again.");
            });

        }
      }
      else {
        const formData = {
          event_id: this.eventId,
          tournamentName: this.tournament_name,
          time_limit: this.tournament_time,
          format: this.tournamentFormat,
          notes: this.tournamentNotes,
          startDateForField: this.startDateForField,
          endDateForField: this.endDateForField,
          startDate: this.exactStartDateformat,
          endDate: this.exactEndDateformat,
          exactStartDate: this.exactStartDate,
          exactEndDate: this.exactEndDate,
          association_id: this.association_id,
          customFormat: this.customFormat,
          pool_play: this.customFormat ? this.poolPlay : '',
          bracket_format: this.customFormat ? this.bracketFormat.id : '',
          rate_id: 0,
          age_group: "",
          pool_play_time: this.poolPlayTime ? this.poolPlayTime : 65,
          bracket_time: this.bracketTime ? this.bracketTime : 70,
          championship_time: this.championshipTime ? this.championshipTime : 80,
        };
        if (this.tournament_id) {
          formData.tournament_id = this.tournament_id;
        }
        this.$set(this.isLoadingArray, index, true);

        axios.post('/associationEvent/createTournament', formData)
          .then(response => {

            if (response.data.statusCode === 200) {
              this.tournament_id = response.data.data.tournament_id;
              this.tournament_guid = response.data.data.tournament_guid;
              this.getTournamentSeedars();
              this.getSeedarsForAssociation(); // Refresh tournaments // Reset form data
              this.$set(this.isLoadingArray, index, false);
              this.nextStep() // Reset loading state
            }
            else if (response.data.statusCode === 404) {
              this.$refs.closeModalAddTournament.click(); // Close modal
              this.$set(this.isLoadingArray, index, false); // Reset loading state
              this.$alert(response.data.message, 'Error');
              this.$router.push({ name: "Teams" });
            }
            else {
              this.$set(this.isLoadingArray, index, false); // Reset loading state
              this.$alert(response.data.message || "An unknown error occurred.");
            }
          })
          .catch(error => {
            // Handle request failure (network/server issue)
            console.error("Request failed: ", error);
            this.$set(this.isLoadingArray, index, false); // Reset loading state
            this.$alert("Failed to create tournament. Please try again.");
          });
      }
    },

    openAddPoolModal(from = "addTournament") {
      this.$refs.closeModalAddTournament?.click();
      setTimeout(() => {
        this.$root.$emit("openAddPoolModal", { tournament_id: this.tournament_id, tournament_guid: this.tournament_guid, source: from });
      }, 100);
    },
    openEditPoolModal(from = "addTournament") {
      if (!this.pools.length) {
        this.$alert("Please add a pool to edit.");
        return;
      }

      // Close the respective modal
      if (from === "addTournament") {
        this.$refs.closeModalAddTournament?.click();
      } else if (from === "editTeam") {
        this.$refs.closeTournamentLineUpModal?.click();
      }

      const selectedPool = this.pools.find(pool => pool.id === this.currentPoolName);

      if (selectedPool) {
        setTimeout(() => {
          this.$root.$emit("openEditPoolModal", {
            id: selectedPool.id,
            name: selectedPool.pool_name,
            tournament_id: this.tournament_id,
            tournament_guid: this.tournament_guid,
            source: from // pass the source modal name
          });
        }, 100);
      } else {
        console.warn("Selected pool not found.");
      }
    },
    handleAvailableTeams(evt) {
      if (evt.added) {
        const addedTeam = evt.added.element;

        // Add to selectedTeams regardless
        this.selectedTeams.push(addedTeam);

        // Remove from availableTeams safely
        if (addedTeam && addedTeam.team && addedTeam.team.id) {
          this.availableTeams = this.availableTeams.filter(team =>
            !team.team || team.team.id !== addedTeam.team.id
          );
        } else {
          // If we can't filter by ID, remove by index
          const index = evt.added.oldIndex;
          if (index >= 0 && index < this.availableTeams.length) {
            this.availableTeams.splice(index, 1);
          }
        }
      }
    },
    handleSelectedTeams(evt) {

      if (evt.removed) {
        const removedTeam = evt.removed.element;

        if (removedTeam === undefined) {
          // If the element is undefined, try to remove by index
          const index = evt.removed.oldIndex;

          if (index >= 0 && index < this.selectedTeams.length) {
            // Remove the item at the index and capture it
            const removedItem = this.selectedTeams.splice(index, 1)[0];

            // If we successfully removed something, add it to available teams
            if (removedItem) {
              this.availableTeams.push(removedItem);
            }
          }
        } else {
          // Normal flow if element exists
          this.availableTeams.push(removedTeam);
          this.selectedTeams = this.selectedTeams.filter(team =>
            team.team && team.team.id !== removedTeam.team.id
          );
        }
      }
    },

    async getTeamsForTournament() {
      try {
        this.showLoaderAvailableTeams = 1;
        this.isDisabled = false;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getJoinedTeamForTournament?event_id=${this.eventId}&tournament_id=${this.tournament_id}`);

        if (response.data.statusCode === 200) {
          this.isDisabled = true;

          this.availableTeams = response.data.data;

          // Inline sorting logic
          this.availableTeams.sort((a, b) => {
            const extractNumber = (str) => parseInt(str.match(/\d+/), 10);
            const isOlder = (str) => str.toLowerCase().includes("older");
            const ageA = a?.team?.age_group?.name || "";
            const ageB = b?.team?.age_group?.name || "";

            const numA = extractNumber(ageA);
            const numB = extractNumber(ageB);

            if (!isOlder(ageA) && !isOlder(ageB)) {
              // Both are U categories
              return numA - numB;
            } else if (isOlder(ageA) && isOlder(ageB)) {
              // Both are Older categories
              return numA - numB;
            } else if (!isOlder(ageA) && isOlder(ageB)) {
              // U category should come before Older category
              return -1;
            } else {
              // Older category should come after U category
              return 1;
            }
          });

          this.showLoaderAvailableTeams = 0;
        } else if (response.data.statusCode === 404) {
          this.isDisabled = true;
        } else {
          this.isDisabled = true;
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderAvailableTeams = 0;
        }
      } catch (error) {
        this.isDisabled = true;
        this.errorMessage = "Failed to fetch data";
        this.showLoaderAvailableTeams = 0;
      }
    },
    async getSelectedTeamsForTournament() {
      this.showLoaderSelectedTeams = 1;
      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/getSelectedTournamentTeams?tournament_guid=${this.tournament_guid}`;
        const response = await axios.get(url);
        if (response.data.statusCode === 200) {
          // this.selectedTeams = response.data.data.teams;
          this.pools_data = response.data.data
          this.pools = response.data.data.pools
          if (this.pools.length > 0) {
            // Sort pools by created_at descending
            const sortedPools = [...this.pools].sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

            // Pick the latest pool
            this.currentPoolName = sortedPools[0].id;

            this.getPoolSelectedTeamsForTournament(this.currentPoolName);
          }
          // Inline sorting logic
          // this.selectedTeams.sort((a, b) => {
          //   const extractNumber = (str) => parseInt(str.match(/\d+/), 10);
          //   const isOlder = (str) => str.toLowerCase().includes("older");

          //   const ageA = a?.team?.age_group?.name || "";
          //   const ageB = b?.team?.age_group?.name || "";

          //   const numA = extractNumber(ageA);
          //   const numB = extractNumber(ageB);

          //   if (!isOlder(ageA) && !isOlder(ageB)) {
          //     // Both are U categories
          //     return numA - numB;
          //   } else if (isOlder(ageA) && isOlder(ageB)) {
          //     // Both are Older categories
          //     return numA - numB;
          //   } else if (!isOlder(ageA) && isOlder(ageB)) {
          //     // U category should come before Older category
          //     return -1;
          //   } else {
          //     // Older category should come after U category
          //     return 1;
          //   }
          // });

          this.showLoaderSelectedTeams = 0;
        } else if (response.data.statusCode === 404) {
          this.showLoaderSelectedTeams = 0;
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
        } else {
          console.error(
            "Failed to fetch teams:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoaderSelectedTeams = 0;
        }
      } catch (error) {
        this.showLoaderSelectedTeams = 0;
        console.error("Failed to fetch teams:", error);
      }
    },
    async getPoolSelectedTeamsForTournament(poolId) {
      this.showLoaderSelectedTeams = 1;
      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/getPoolSelectedTournamentTeams?tournament_guid=${this.tournament_guid}&pool_id=${poolId}`;
        const response = await axios.get(url);
        if (response.data.statusCode === 200) {
          this.selectedTeams = response.data.data.teams;
          // Inline sorting logic
          this.selectedTeams.sort((a, b) => {
            const extractNumber = (str) => parseInt(str.match(/\d+/), 10);
            const isOlder = (str) => str.toLowerCase().includes("older");

            const ageA = a?.team?.age_group?.name || "";
            const ageB = b?.team?.age_group?.name || "";

            const numA = extractNumber(ageA);
            const numB = extractNumber(ageB);

            if (!isOlder(ageA) && !isOlder(ageB)) {
              // Both are U categories
              return numA - numB;
            } else if (isOlder(ageA) && isOlder(ageB)) {
              // Both are Older categories
              return numA - numB;
            } else if (!isOlder(ageA) && isOlder(ageB)) {
              // U category should come before Older category
              return -1;
            } else {
              // Older category should come after U category
              return 1;
            }
          });

          this.showLoaderSelectedTeams = 0;
        } else if (response.data.statusCode === 404) {
          this.showLoaderSelectedTeams = 0;
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
        } else {
          console.error(
            "Failed to fetch teams:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoaderSelectedTeams = 0;
        }
      } catch (error) {
        this.showLoaderSelectedTeams = 0;
        console.error("Failed to fetch teams:", error);
      }
    },
    //     async assignTeamsToPool() {
    //   if (!this.currentPoolName) {
    //     this.errorMessage = "Please select a pool.";
    //     return;
    //   }

    //   if (this.selectedTeams.length === 0) {
    //     this.errorMessage = "No teams selected.";
    //     return;
    //   }

    //   const currentPool = this.pools.find(p => p.id === this.currentPoolName);
    //   if (!currentPool) {
    //     this.errorMessage = "Selected pool does not exist.";
    //     return;
    //   }

    //   if (!Array.isArray(currentPool.teams)) {
    //     this.$set(currentPool, 'teams', []);
    //   }

    //   const existingIds = currentPool.teams.map(team => team.team?.id);
    //   const newTeams = this.selectedTeams.filter(
    //     team => !existingIds.includes(team.team?.id)
    //   );

    //   // Only add new teams (avoid duplicates)
    //   currentPool.teams.push(...JSON.parse(JSON.stringify(newTeams)));

    //   // Remove newly assigned teams from availableTeams
    //   const assignedIds = newTeams.map(team => team.team?.id);
    //   this.availableTeams = this.availableTeams.filter(
    //     team => !assignedIds.includes(team.team?.id)
    //   );

    //   this.selectedTeams = [];
    //   this.errorMessage = "";

    //   // Hit the backend API with ONLY the current pool
    //   try {
    //     const url = `${process.env.VUE_APP_API_URL}tournaments/teams/addTeamsToPools`;

    //     const payload = {
    //       event_id: this.eventId,
    //       tournament_id: this.tournament_id,
    //       tournament_guid: this.tournament_guid,
    //       pools: [
    //         {
    //           id: currentPool.id,
    //           teams: currentPool.teams
    //         }
    //       ]
    //     };

    //     this.isLoading = true;
    //     const response = await axios.post(url, payload);
    //     this.isLoading = false;

    //     if (response.data.statusCode === 200) {
    //       if (response.data.associatedTeam === 1) {
    //         this.$alert(response.data.message);
    //       } else {
    //         this.$alert(response.data.message, "Success");
    //       }

    //       this.$root.$emit("selectedTournamentTeamEmit");
    //       this.$root.$emit("fetchTournaments");

    //       const elem = this.$refs.openAddTournamentModal;
    //       this.dataReset();
    //       if (elem) {
    //         elem.click();
    //       }
    //     } else if (response.data.statusCode === 404) {
    //       this.$alert(response.data.message, "Error");
    //       this.$router.push({ name: "Teams" });
    //     } else {
    //       console.error("Failed to assign teams. Status:", response.status);
    //     }
    //   } catch (error) {
    //     this.isLoading = false;
    //     console.error("Error assigning teams to pool:", error);
    //     this.$alert("Failed to assign teams to pool", "Error");
    //   }
    // }

    async assignTeamsToPool() {
      if (!this.currentPoolName) {
        this.errorMessage = "Please select a pool.";
        return;
      }

      // if (this.selectedTeams.length === 0) {
      //   this.errorMessage = "No teams selected.";
      //   return;
      // }

      const currentPool = this.pools.find(p => p.id === this.currentPoolName);
      if (!currentPool) {
        this.errorMessage = "Selected pool does not exist.";
        return;
      }

      // Important change: Always use the currently selectedTeams as the source of truth
      // This ensures we send exactly what the user has selected in the UI

      // Hit the backend API with the current pool and its CURRENTLY SELECTED teams
      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/addTeamsToPools`;

        const payload = {
          event_id: this.eventId,
          tournament_id: this.tournament_id,
          tournament_guid: this.tournament_guid,
          pools: [
            {
              id: currentPool.id,
              teams: JSON.parse(JSON.stringify(this.selectedTeams)) // Send the exact selected teams
            }
          ]
        };

        this.isLoading = true;
        const response = await axios.post(url, payload);
        this.isLoading = false;

        if (response.data.statusCode === 200) {
          // Update the currentPool teams in the local state
          this.$set(currentPool, 'teams', JSON.parse(JSON.stringify(this.selectedTeams)));
          if (response.data.associatedTeam === 1) {
            this.$alert(response.data.message);
            this.getSelectedTeamsForTournament();
          } else {
            this.getSelectedTeamsForTournament();
            // this.$alert(response.data.message, "Success");
          }

          this.$root.$emit("selectedTournamentTeamEmit");
          this.$root.$emit("fetchTournaments");

          // const elem = this.$refs.openAddTournamentModal;
          // this.dataReset();
          // if (elem) {
          //   elem.click();
          // }
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to assign teams. Status:", response.status);
        }
      } catch (error) {
        this.isLoading = false;
        console.error("Error assigning teams to pool:", error);
        this.$alert("Failed to assign teams to pool", "Error");
      }
    },
    async manageTournamentTeam(index) {
      if (!this.currentPoolName) {
        this.errorMessage = "Please select a pool.";
        return;
      }
      this.isDisabled = false;
      this.$set(this.isLoadingArray, index, true);

      const currentPool = this.pools.find(p => p.id === this.currentPoolName);
      if (!currentPool) {
        this.errorMessage = "Selected pool does not exist.";
        return;
      }
      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/addTeamsToPools`;

        const response = await axios.post(url, {
          event_id: this.eventId,
          tournament_id: this.tournament_id,
          tournament_guid: this.tournament_guid,
          pools: [
            {
              id: currentPool.id, // assuming you have a currentPool defined in data or computed
              teams: JSON.parse(JSON.stringify(this.selectedTeams)) // deep copy of selected teams
            }
          ]
        });

        if (response.data.statusCode === 200) {
          this.isDisabled = true;

          if (response.data.associatedTeam === 1) {
            this.$alert(response.data.message);
          } else {
            // this.$alert(response.data.message, "Success");
          }

          this.$root.$emit("selectedTournamentTeamEmit");
          this.$root.$emit("fetchTournaments");
          this.$root.$emit("ReloadTabs");

          const elem = this.$refs.closeModalAddTournament;
          if (elem) {
            elem.click();
          }
          this.dataReset2();


        } else if (response.data.statusCode === 404) {
          this.isDisabled = true;
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to add teams. Status:", response.status);
        }

      } catch (error) {
        console.error("Error saving selected teams:", error);
      } finally {
        this.isDisabled = true;
        this.$set(this.isLoadingArray, index, false);
      }
    },

  },
  mounted() {
    this.filteredAvailableTeams = [];
    this.getEventSeedars();
    this.$root.$on("openAddTournamentModal", () => {
      const elem = this.$refs.openModalAddTournament;
      if (elem) {
        elem.click();
        this.dataReset();
        this.dataReset2();
      }
      this.initializeDate();
    });
    this.$root.$on("refreshPool", ({ tournament_id, tournamentguid }) => {
      this.tournament_id = tournament_id; // set tournament_id in data
      this.tournament_guid = tournamentguid; // set tournament_id in data
      this.selectedTeams = [];
      this.availableTeams = [];
      this.getTeamsForTournament();
      this.getSelectedTeamsForTournament();
    });
  },
};
</script>